<div class="configure">
    <span class="label-text">* Required Fields</span>

    <div class="disp-flex" cdkDropListGroup>
        <div class="left-flex">
            <app-field-picker-tree
                [isAttached]="isAttached"
                [tree]="groupedMetadata"
                [readonly]="isReadOnly"
                (dragStateChanged)="dragStateChanged($event)">
            </app-field-picker-tree>
        </div>

        <div class="right-flex">
            @for (zone of dropZones; track zone.id) {
                <app-ddv-configuration-zone
                    [zone]="zone"
                    [dataConfigs]="dataConfigs[zone.configKey] ?? []"
                    [isReadOnly]="isReadOnly"
                    [activelyDragging]="activelyDragging"
                    [visualizationType]="visualizationType"
                    (configurationZoneChange)="onConfigurationZoneChange($event)"
                    (configurationFieldDrop)="onConfigurationFieldDrop($event)">
                </app-ddv-configuration-zone>
            }
        </div>
    </div>
</div>
